import { PHONE_NUMBER } from "../constants/regex";

export default (number) => PHONE_NUMBER.test(number);
